import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-draw'
import 'leaflet-draw/dist/leaflet.draw.css'
import { App, reactive } from 'vue'

// Fix default marker icon path issue with webpack/vite
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'
// @ts-ignore
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({ iconUrl, iconRetinaUrl, shadowUrl })

export function useGMapManage () {
  const state = reactive({
    map: null as L.Map | null,
    mouseTool: null as any, // Leaflet.Draw control
  })

  async function initMap (container: string, app: App) {
    const map = L.map(container, {
      center: [36.5, 127.5], // 한국 중심 좌표
      zoom: 7,
      zoomControl: true,
    })

    // OpenStreetMap 무료 타일 (API 키 불필요)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 18,
    }).addTo(map)

    // Leaflet.Draw 편집 레이어 (비행구역 그리기용)
    const drawnItems = new L.FeatureGroup()
    map.addLayer(drawnItems)

    const drawControl = new (L as any).Control.Draw({
      edit: { featureGroup: drawnItems },
      draw: {
        polyline: false,
        rectangle: false,
        marker: false,
        circlemarker: false,
        circle: { shapeOptions: { color: '#2D8CF0' } },
        polygon: { shapeOptions: { color: '#2D8CF0' } },
      },
    })

    state.map = map
    state.mouseTool = { drawControl, drawnItems }

    // 전역 프로퍼티에 마운트
    app.config.globalProperties.$map = map
    app.config.globalProperties.$aMap = L // L을 $aMap 자리에 넣어 기존 코드 호환
    app.config.globalProperties.$mouseTool = state.mouseTool
  }

  function globalPropertiesConfig (app: App) {
    initMap('g-container', app)
  }

  return {
    globalPropertiesConfig,
  }
}
